import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Row, Col, Form, Input, DatePicker, AutoComplete } from "antd";
import { EditViewSingle, EditViewMulti } from "components/EditView";
import socialCandModel from "store/reducers/socialCandModel";
import { commonData } from "services/commonService";
import moment from "moment";
import _ from "underscore";
import { disabledEndDate, disabledStartDate } from "utils/formVerify";
import { MonthPickerSofar } from "components/DatePickerSofarWrap";
import updateCompletewrapper from "./update-complete-wrapper";

const FormItem = Form.Item;
const { MonthPicker } = DatePicker;
const { TextArea } = Input;

export function mapPropsToFields(props) {
  const { item } = props;
  const formFileds = _.mapObject(item, function(val, key) {
    return Form.createFormField({
      ...val,
      value: val && val.value
    });
  });
  return formFileds;
}

export function fieldsToProps(values) {
  const { begin_time, end_time } = values;
  values.begin_time = begin_time && begin_time.format("YYYY/MM");
  values.end_time =
    typeof end_time !== "string" ? end_time.format("YYYY/MM") : end_time;
  return values;
}

export function onFieldsChange(props, changedFields) {
  props.onChange(changedFields);
}

export function createProjectExperienceEditForm(
  mapPropsToFields,
  fieldsToProps,
  onFieldsChange
) {
  return Form.create({
    mapPropsToFields,
    onFieldsChange
  })(
    class EditForm extends PureComponent {
      state = {
        beginTime: null,
        endTime: null,
        dataSource: []
      };

      handleSubmit = () => {
        return new Promise((resolve, reject) => {
          this.props.form.validateFieldsAndScroll({scroll: {offsetBottom: 60}},(err, values) => {
            if (!err) {
              resolve(fieldsToProps ? fieldsToProps(values) : values);
            } else {
              reject(err);
            }
          });
        });
      };

      onDateChange = (field, date) => {
        this.setState({ [field]: date });
      };

      handleSearch = value => {
        const { jobCompanies } = this.props;
        this.setState({
          dataSource: jobCompanies.filter(item => item.indexOf(value) !== -1)
        });
        console.log("value", value);
      };

      render() {
        const formItemLayout = {
          labelCol: { span: 5 },
          wrapperCol: { span: 19 }
        };

        const { getFieldDecorator } = this.props.form;
        const { endTime, beginTime, dataSource } = this.state;
        return (
          <div className="project-experience-edit">
            <Form className="edit-form" layout="horizontal">
              <Row className="one" gutter={35}>
                <Col span={12}>
                  <FormItem label="项目名称" {...formItemLayout}>
                    {getFieldDecorator("project_name", {
                      rules: [
                        {
                          required: true,
                          message: "请输入项目名称，且最大60个字符",
                          max: 60
                        }
                      ]
                    })(<Input placeholder="请输入项目名称" size="large" />)}
                  </FormItem>
                </Col>
                <Col span={12}>
                  <div className="form-item-period clear">
                    <FormItem
                      label="起止时间"
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 15 }}
                    >
                      {getFieldDecorator("begin_time", {
                        rules: [
                          {
                            required: true,
                            message: "请选择起止时间"
                          }
                        ]
                      })(
                        <MonthPicker
                          size="large"
                          format="YYYY/MM"
                          disabledDate={disabledStartDate.bind(null, endTime)}
                          onChange={this.onDateChange.bind(this, "beginTime")}
                        />
                      )}
                    </FormItem>
                    &nbsp;&nbsp;~&nbsp;&nbsp;
                    <FormItem>
                      {getFieldDecorator("end_time", {
                        rules: [
                          {
                            required: true,
                            message: "请选择起止时间"
                          }
                        ]
                      })(
                        <MonthPickerSofar
                          size="large"
                          format="YYYY/MM"
                          disabledDate={disabledEndDate.bind(null, beginTime)}
                          onChange={this.onDateChange.bind(this, "endTime")}
                        />
                      )}
                    </FormItem>
                  </div>
                </Col>
              </Row>
              <Row className="two" gutter={35}>
                <Col span={12}>
                  <FormItem label="所属公司" {...formItemLayout}>
                    {getFieldDecorator("company_name", {
                      rules: [{ message: "所属公司最大60个字符", max: 60 }]
                    })(
                      <AutoComplete
                        placeholder="请输入所属公司"
                        dataSource={dataSource}
                        size="large"
                        onSearch={this.handleSearch}
                      />
                    )}
                  </FormItem>
                </Col>
              </Row>
              <Row className="three" gutter={35}>
                <Col span={24}>
                  <FormItem
                    label="项目描述"
                    labelCol={{ span: 2 }}
                    wrapperCol={{ span: 22 }}
                  >
                    {getFieldDecorator("description", {
                      rules: []
                    })(
                      <TextArea
                        placeholder="项目描述"
                        autosize={{ minRows: 2, maxRows: 6 }}
                      />
                    )}
                  </FormItem>
                </Col>
              </Row>
              <Row className="four" gutter={35}>
                <Col span={24}>
                  <FormItem
                    label="责任描述"
                    labelCol={{ span: 2 }}
                    wrapperCol={{ span: 22 }}
                  >
                    {getFieldDecorator("duty", {
                      rules: []
                    })(
                      <TextArea
                        placeholder="责任描述"
                        autosize={{ minRows: 2, maxRows: 6 }}
                      />
                    )}
                  </FormItem>
                </Col>
              </Row>
            </Form>
            <style jsx global>
              {`
                .form-item-period {
                  .ant-form-item {
                    display: inline-block;
                  }
                  .ant-form-item:first-child {
                    width: 58%;
                    .ant-form-item-label {
                      width: 35%;
                    }
                  }
                  .ant-form-item:last-child {
                    width: 34%;
                  }
                }
                .project-experience-edit {
                  :global(.three),
                  :global(.four) {
                    :global(.ant-form-item-label) {
                      width: 10%;
                    }
                    :global(.ant-form-item-control-wrapper) {
                      width: 90%;
                      :global(.ant-input) {
                        height: 100px;
                        resize: none;
                      }
                    }
                  }
                }
              `}
            </style>
          </div>
        );
      }
    }
  );
}

export const ProExperienceEditForm = createProjectExperienceEditForm(
  mapPropsToFields,
  fieldsToProps
);

export const AddProExpEditForm = createProjectExperienceEditForm(
  mapPropsToFields,
  fieldsToProps,
  onFieldsChange
);

export function ProjectExperienceView(props) {
  const { item } = props;
  return (
    <div className="pro-experience-view">
      <Row gutter={10} className="pro-experience-item">
        <Col span={4}>
          {item.begin_time.value.format("YYYY/MM")}-
          {typeof item.end_time.value === "string"
            ? item.end_time.value
            : item.end_time.value.format("YYYY/MM")}
        </Col>
        <Col span={18}>
          <Row gutter={5} className="pro-experience-title">
            <Col span={24}>{item.project_name.value}</Col>
          </Row>
          <Row gutter={5}>
            <Col span={24}>所属公司：{item.company_name.value}</Col>
          </Row>
          <div className="pro-content">
            <div>项目描述 :</div>
            <pre>{item.description.value}</pre>
          </div>
          <div className="pro-content">
            <div>责任描述 :</div>
            <pre>{item.duty.value}</pre>
          </div>
        </Col>
      </Row>
      <style jsx>
        {`
          .pro-experience-view {
            :global(.pro-experience-item) {
              margin-bottom: 28px;
              &:last-child {
                margin-bottom: 0;
              }
              .pro-content {
                > div {
                  font-weight: 600;
                }
              }
            }
            :global(.ant-row) {
              margin-bottom: 18px;
              color: #666;
            }
            :global(.pro-experience-title) {
              font-weight: 600;
            }
          }
        `}
      </style>
    </div>
  );
}

class ProjectExperience extends PureComponent {
  state = {
    topPlaceholderBg: "#ffffff",
    bottomPlaceholderBg: "#ffffff"
  };

  setPlaceholderColor = (index, color) => {
    const { proExperiences } = this.props;
    index === proExperiences.length - 1
      ? this.setState({ bottomPlaceholderBg: color })
      : !1;
    index === 0 ? this.setState({ topPlaceholderBg: color }) : !1;
  };

  onEdit = index => {
    this.setPlaceholderColor(index, "#f0f0f0");
    this.props.updateProExperience({ index, values: { isEdit: true } });
  };

  onCancel = index => {
    this.setPlaceholderColor(index, "#ffffff");
    this.props.cancelProExperience(index);
  };

  onSave = index => {
    const { saveProExperience } = this.props;
    this.formRef.handleSubmit().then(values => {
      saveProExperience(index, values)
        .then(res => {
          if (res.code === 0) this.setPlaceholderColor(index, "#ffffff");
          return res;
        })
        .then(res => (!res.code ? res.data.compete : null))
        .then(this.props.toUpdateComplete);
    });
  };

  onDelete = index => {
    this.props
      .removeProExperience(index)
      .then(res => (!res.code ? res.data.compete : null))
      .then(this.props.toUpdateComplete);
  };

  onAdd = () => {
    const { proExperiences } = this.props;
    if (!proExperiences.length) {
      this.setPlaceholderColor(-1, "#f0f0f0");
      this.setPlaceholderColor(0, "#f0f0f0");
    } else {
      this.setState({ bottomPlaceholderBg: "#f0f0f0" });
    }
    this.props.addProExperience({ limit: true });
  };

  render() {
    const { topPlaceholderBg, bottomPlaceholderBg } = this.state;
    const { proExperiences, jobCompanies } = this.props;
    return (
      <EditViewMulti
        className="project-experience"
        title="项目经历"
        onAdd={this.onAdd}
      >
        <div className="placeholder" style={{ background: topPlaceholderBg }} />
        {proExperiences.map((item, index) => (
          <EditViewSingle
            isView={!item.isEdit}
            onEdit={() => this.onEdit(index)}
            onCancel={() => this.onCancel(index)}
            onSave={() => this.onSave(index)}
            onDelete={() => this.onDelete(index)}
            className={`${index === proExperiences.length - 1 ? "last" : ""}`}
            key={item.project_id}
          >
            <div role="view" className="view">
              <ProjectExperienceView item={item} />
            </div>
            <div role="edit" className="edit">
              <ProExperienceEditForm
                item={item}
                jobCompanies={jobCompanies}
                wrappedComponentRef={inst => (this.formRef = inst)}
              />
            </div>
          </EditViewSingle>
        ))}
        <div
          className="placeholder"
          style={{ background: bottomPlaceholderBg }}
        />
        {/* 移除 styled-jsx，使用普通 CSS 类 */}
      </EditViewMulti>
    );
  }
}

export default connect(
  ({ socialCandidate }) => {
    return {
      proExperiences: socialCandidate.candidate.detail.proExperiences || [],
      jobCompanies: (socialCandidate.candidate.detail.jobExperiences || []).map(
        item => (item.company_name || {}).value
      )
    };
  },
  { ...socialCandModel.actions }
)(updateCompletewrapper(ProjectExperience));
